import React from "react";
import { AbstractDate } from "@linkfluence/models/date";
import { DatavizLineChart } from "@radarly/models/dataviz";
import { SearchFragmentDateMetrics } from "@radarly/models/search";
import { useFragmentData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export interface SharedWidgetsMetricsLineChartProps {
  project: number;
  fragment: SearchFragmentDateMetrics;
  dataviz: DatavizLineChart;
  onClickPoint?: (
    uid: string | number,
    range: { from: Date; to: Date }
  ) => void;
  className?: string;
  forceReload?: boolean;
  disableAnimation?: boolean;
  nowDate?: AbstractDate;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsMetricsLineChart({
  project,
  fragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickPoint,
  ...props
}: SharedWidgetsMetricsLineChartProps) {
  const { loading, data } = useFragmentData(project, fragment);
  const _onClickPoint = (
    uid: string | number,
    range: { from: Date; to: Date }
  ) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickPoint(uid, range);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        loading={loading}
        data={data}
        fragment={fragment}
        isFullscreen={isFullscreen}
        onClickPoint={_onClickPoint}
        {...props}
      />
    </Loading>
  );
}
